// Adding a value to a controlled list, without leaving the capture form.
//
// A modal, deliberately: the alternative is navigating away from a half-filled form to an admin
// screen, which loses the work. <dialog> so focus and Escape behave; never window.confirm or
// window.alert, which block the page.
//
// Display name is asked for first because that is what the person has: someone adding "Metric
// tonnes" knows what it should read as and is inventing the stored value second. The API still
// takes code and label - this is what the fields are called to a BD, not a rename of what is
// persisted.

import { useState } from 'react';

import Modal from '../../ui/Modal.jsx';
import { addReferenceEntry } from '../../api.js';
import { sampleFor } from './listSamples.js';

export default function AddEntryDialog({ listName, label, onClose, onAdded }) {
  const [value, setValue] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const sample = sampleFor(listName);


  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onAdded(await addReferenceEntry(listName, value, displayName));
    } catch (err) {
      setError(err.status === 409 ? 'That value is already in the list.' : err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <form onSubmit={onSubmit}>
        <h3>Add to {label}</h3>
        <p className="hint">
          Everyone sees this immediately, and it is recorded against your name.
        </p>
        <label>
          Display name
          <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} required
                 placeholder={sample.displayName} />
        </label>
        <label>
          Value
          <input value={value} onChange={(e) => setValue(e.target.value)} required
                 placeholder={sample.value} />
        </label>
        {error && <p className="error">{error}</p>}
        <menu>
          <button type="button" onClick={onClose}>Cancel</button>
          <button type="submit" disabled={busy}>{busy ? 'Adding…' : 'Add'}</button>
        </menu>
      </form>
    </Modal>
  );
}
